import { useForm } from '@mantine/form';

import { trafficSourceTypes } from '../types';

export type Fields = Omit<trafficSourceTypes.TrafficSource, '_id'>;
type TrafficSourceFormProps = {
  initialValues: Fields;
};

export const useTrafficSourceForm = ({ initialValues }: TrafficSourceFormProps) => {
  return useForm({
    initialValues: {
      name: initialValues.name,
      key: initialValues.key,
      command: initialValues.command,
    },

    validate: {
      name: (value: string) => (!value ? 'Name is required' : null),
      key: (value: string) => (!value ? 'Key is required' : null),
      command: (value: string) => (!value ? 'Command is required' : null),
    },
  });
};
